import * as moment from 'moment'

const getDateFormat = () => moment.localeData().longDateFormat("L")


export class Validator {
  static email(value) {
    return value && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? 'Le format de l’email est incorrect' : undefined
  }

  static phone(value){
    return value && !/^[0-9-.() ]*$/i.test(value) ? 'Le format du téléphone est incorrect' : undefined
  }

  static siren(value){
    return value && !/^[0-9]*$/i.test(value) ? 'Le format du siren est incorrect' : undefined
  }

  static frMobile(value){
    return value && !/^(^[+]33|33|0)(6|7|9)\d{8}$/i.test(value) ? 'Le format du téléphone est incorrect' : undefined
  }

  static customMobilePhone(value){
    const checkPhoneTest = (phone) => {
        if(phone.toString().startsWith("0")){
            return !/^(0)(6|7|9)\d{8}$/i.test(phone)
        } else if(phone.toString().startsWith("+33")){
            return !/^(\+33)(6|7|9)\d{8}$/i.test(phone)
        } else {
            return !/^(\+44)(7)\d{9}$/i.test(phone)
        }
    }
    return value && checkPhoneTest(value) ? 'Le format du téléphone est incorrect' : undefined
}

static customMobileFix(value){
    const checkPhoneTest = (phone) => {
        if(phone.toString().startsWith("00377")){
          return !/^(00377)\d{7}$/i.test(phone)
        } else if(phone.toString().startsWith("0")){
            return !/^(0)\d{9}$/i.test(phone)
        } else if(phone.toString().startsWith("+377")) {
          return !/^(\+377)\d{7}$/i.test(phone)
        }else if(phone.toString().startsWith("+33")){
            return !/^(\+33)\d{9}$/i.test(phone)
        } else {
            return !/^(\+44)\d{10}$/i.test(phone)
        }
    }
    return value && checkPhoneTest(value) ? 'Le format du téléphone est incorrect' : undefined
}

  static required(value){
    // return value !== undefined ? undefined : 'Obligatoire'
    return (value !== undefined || (value && value.length !== 0)) ? undefined : 'Obligatoire'
  }

  static negativeNumberRequired(value){
    return value !== undefined ? undefined : 'Obligatoire'
  }

  static maxLength = max => value =>{
    return value && value.length > max ? `Maximum ${max} caractères` : undefined
  }

  static minLength = min => value =>{
    return value && value.length < min ? `Minimum ${min} caractères` : undefined
  }

  static numberBetween = (min, max) => value =>{
    return value && parseFloat(value) > max || parseFloat(value) < min ? `La valeur doit être entre ${min} et ${max}` : undefined
  }

  static positiveNumber(value){
    return value && parseFloat(value) < 0 ? 'La valeur renseignée doit être positive' : undefined
  }

  static date = x => {
    return (x && !moment(new Date(x), getDateFormat(), true).isValid()) ? 'Date invalide' : undefined;
  };

  static mustBeAfter = (date) => x => {
    return (x && date && !moment(x).isAfter(moment(date))) ?
      `La date saisie doit être après le ${moment(date).format(getDateFormat())}` : undefined;
  };

  static mustBeBefore = (date) => x => {
    return (x && date && !moment(x).isBefore(moment(date))) ?
      `La date saisie doit être avant le ${moment(date).format(getDateFormat())}`
      : undefined;
  };

  static password(value){
    let isSetted: boolean = true;
    let isLengthCorrect: boolean = false;
    let hasNumber : boolean = false;
    let identicalChar: boolean = false;
    let exceedMaxReps: boolean = false;

    if(!value) isSetted = false;

    if(value){
      isSetted = true;
      if(value.length <= 16 && value.length >= 10){
        isLengthCorrect = true;
      }
      if(/\d/.test(value)) hasNumber = true;
      if(new RegExp('.*^((.)\\2?(?!\\2))+$').test(value)) identicalChar = true;
      for(let i=0;i < value.length;i++) {
        const char = value.charAt(i);
        if (value.split('').filter(x => x === char).length > 3) {
          exceedMaxReps = true;
        }
      }
    }

    return (isSetted && isLengthCorrect && hasNumber && identicalChar && !exceedMaxReps) ? undefined : 'Mauvais format de mot de passe';
  }

  static passwordConfim = oldPassword => value => {
    return (value && oldPassword !== value) ?  'Les mots de passe ne sont pas identiques !' : undefined;
  };

  static build(values, validators){
    const errors = {};

    Object.keys(validators).forEach(f => {
      const validations = validators[f];
      const vals = values[f];
      if(!Array.isArray(validations)) {
        errors[f] = Validator.build(vals || {}, validations);
      } else {
        validations.forEach(v => {
          const error = v(values[f]);
          if(error) errors[f] = error;
        })
      }
    });
    return errors;
  }

  static buildWithCheckAll(values, validators, checkAll){
    const errors = {};

    Object.keys(validators).forEach(f => {
      const validations = validators[f];
      const vals = values[f];
      if(!Array.isArray(validations)) {
        errors[f] = Validator.build(vals || {}, validations);
      } else {
        validations.forEach(v => {
          const error = v(values[f]);
          if(error) errors[f] = error;
        })
      }
    });
    
    return {
      ...errors, 
      ...(checkAll(values) !== undefined && {check_all: checkAll(values)})
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/form/Validator.tsx